import(/* webpackMode: "eager" */ "/opt/buildhome/repo/packages/web/src/app/(no-sidebar)/quick-trade/page.tsx");
